'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isBoolean(x) {
    return typeof x === 'boolean';
}
exports.isBoolean = isBoolean;
